module.exports = __webpack_public_path__ + "static/background-c7f56ab9a0e25a0000c8adc1f6d4b4bc.jpg";